export class SetVirtualTour {
	static readonly type = '[Quality] SetVirtualTour';

	constructor(public orderId: number) {}
}
